<template>
  <v-card class="mx-6 mt-6 banner__newLive" flat>
    <div class="d-flex justify-center container__title">
      <div class="d-flex align-center mr-5">
        <v-icon color="#fff" size="40">mdi-access-point</v-icon>
      </div>
      <div class="d-flex flex-column mr-md-9 contentBanner">
        <span class="text-h6 font-weight-medium white--text">{{
          $i18next.t('message.banners.newLive.title')
        }}</span>
        <span class="subtitle white--text font-weight-regular">{{
          $i18next.t('message.banners.newLive.subtitle')
        }}</span>
      </div>
      <div class="d-flex align-center">
        <div class="mb-md-1 mt-md-0 mt-2">
          <BaseBtn
            type="tertiary"
            @click="getNewLive"
            class="bg-dark--ignore"
            >{{ $i18next.t('message.banners.newLive.action') }}</BaseBtn
          >
        </div>
      </div>
    </div>
    <div class="close-banner">
      <v-icon color="white" size="20px" @click="handleClose">mdi-close</v-icon>
    </div>
  </v-card>
</template>

<script>
import BaseBtn from '@/components/BaseBtn.vue'
import Storage from '@/utils/Storage'

export default {
  name: 'newLiveBanner',
  components: { BaseBtn },
  computed: {
    locale() {
      return this.$i18next.resolvedLanguage
    },
  },
  methods: {
    getNewLive() {
      Storage.setItem('oldLive', false)
      this.$router.push({ name: 'LiveV2' })
    },
    handleClose() {
      Storage.setItem('hasClosedNewLiveBanner', true)
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.close-banner {
  position: absolute;
  right: 8px;
  top: 4px;
}

.banner__newLive {
  min-height: 90px;
  height: 118px;
  border-radius: 4px;
  background: linear-gradient(93deg, #182996 13.31%, #425af0 67.78%), #a0acff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0px;

  .contentBanner {
    max-width: 579px;
  }
}

.mirror {
  -webkit-transform: scaleX(-1) scaleY(-1);
  transform: scaleX(-1) scaleY(-1);
}

.subtitle {
  font-size: 18px;
  color: #e1dbff;
}

.page-view {
  &__container.has-pre-content {
    grid-template-areas: 'header-mobile' 'pre-content' 'content' 'header' !important;
    grid-template-rows: auto auto 1fr auto !important;

    @media (min-width: 680px) {
      grid-template-areas: 'header' 'pre-content' 'content' !important;
      grid-template-rows: auto auto 1fr !important;
    }
  }
}

.page-view__container.c.has-pre-content,
.page-view__container.ac.has-pre-content {
  grid-template-rows: 75px auto calc(100vh - 189px) !important;
}

@media screen and (max-width: 1279px) {
  .hide-mobile {
    display: none !important;
  }

  .banner__newLive {
    justify-content: center;
  }
}

@media screen and (max-width: 982px) {
  .container__title {
    flex-direction: column;
  }

  .page-view__container.c.has-pre-content,
  .page-view__container.ac.has-pre-content {
    grid-template-rows: 75px auto calc(100vh - 249px) !important;
  }

  .banner__newLive {
    height: unset;
  }
}

@media screen and (max-width: 679px) {
  .page-view__container.c.has-pre-content,
  .page-view__container.ac.has-pre-content {
    grid-template-rows: auto auto 1fr auto !important;
  }
}

@media screen and (max-width: 572px) {
  .banner__newLive {
    padding: 20px 20px;
  }
}
</style>
